import { createAsyncThunk } from "@reduxjs/toolkit";
import { getDomainAdminService } from "../../api/generated/domainAdmin";
import { AXIOS_INSTANCE } from "../../api/generatedClientConfig";
import { setUserRole, setUserRoleLoading } from "../appStateSlice";

const api = getDomainAdminService();

function parseUserRole(data: unknown): string {
  if (typeof data === 'string') {
    return data;
  }
  if (data && typeof data === 'object') {
    const record = data as Record<string, unknown>;
    if (typeof record.role === 'string') return record.role;
    if (typeof record.userRole === 'string') return record.userRole;
    if (Array.isArray(record.roles) && record.roles.length > 0) return String(record.roles[0]);
  }
  return 'None';
}

export const isUserDomainAdmin = (role?: string | null): boolean =>
  role?.toLowerCase() === 'domainadmin';

export const isUserSuperAdmin = (role?: string | null): boolean => {
  const normalized = role?.toLowerCase();
  return normalized === 'superadmin' || normalized === 'admin';
};

export const isUserAuthorized = (role?: string | null): boolean =>
  isUserDomainAdmin(role) || isUserSuperAdmin(role);

export const fetchCurrentUserRole = createAsyncThunk(
  'auth/fetchCurrentUserRole',
  async (_, { dispatch, getState }) => {
    const state = getState() as any;
    // Only show full-screen loader on cold start when role is not yet known
    if (!state.appState.userRole) {
      dispatch(setUserRoleLoading(true));
    }
    try {
      let roleStr = 'None';
      try {
        const res = await api.getMeRole();
        roleStr = parseUserRole(res);
      } catch (err: any) {
        if (err?.response?.status === 404) {
          const res = await AXIOS_INSTANCE.get('/me');
          roleStr = parseUserRole(res.data);
        } else {
          throw err;
        }
      }
      dispatch(setUserRole(roleStr));
      return roleStr;
    } catch {
      dispatch(setUserRole('None'));
      return 'None';
    } finally {
      dispatch(setUserRoleLoading(false));
    }
  }
);
